import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaSuministro', NominasNominaSuministro)

function NominasNominaSuministro($api) {
  let self = this
  self.get = get
  self.editar = editar
  self.object = {
    deduccionesCalculadas: deduccionesCalculadas,
  }

  function deduccionesCalculadas(deducciones) {
    function Deducciones() {
      angular.forEach(deducciones, function (deduccion, idConcepto) {
        this[idConcepto] = {
          calculado: deduccion.calculado,
          editado: deduccion.editado,
          folio: deduccion.folio,
        }
      }, this)
    }

    Deducciones.prototype.get = function (idConcepto) {
      let deduccion = this[idConcepto]

      return angular.isNumber(deduccion.editado)
        ? {idConcepto: idConcepto, importe: deduccion.editado, editado: true}
        : {idConcepto: idConcepto, importe: deduccion.calculado, editado: false}
    }

    Deducciones.prototype.total = function () {
      let total = 0

      angular.forEach(deducciones, function (importe, idConcepto) {
        total += this.get(idConcepto).importe
      }, this)

      return total
    }

    return new Deducciones()
  }

  function get(idEmpresa, idNomina) {
    return $api.get('kendu/nominas/nomina/deducciones', {
        idEmpresa: idEmpresa,
        idNomina: idNomina,
      }, {cache: 'nominas'})
      .then(function (data) {
        return data.map(function (item) {
          return {
            ID_Empleado: item.ID_Empleado,
            ID_Empresa: item.ID_Empresa,
            Deducciones: deduccionesCalculadas(item.Deducciones),
            Ediciones: item.Ediciones,
            Comision_Importe: Number(item.Comision_Importe),
            Comision_Porcentaje: Number(item.Comision_Porcentaje),
            Saldo: Number(item.Saldo),
            Subtotal: Number(item.Subtotal),
            Total: Number(item.Total),
          }
        })
      })
  }

  function editar(idNomina, idEmpresa, idEmpleado, idConcepto, importe, fecha) {
    return $api.update('kendu/nominas/nomina/deducciones/editar', {
      idNomina: idNomina,
      idEmpresa: idEmpresa,
      idEmpleado: idEmpleado,
    }, {
      idConcepto: idConcepto,
      importe: importe,
      fecha: fecha,
    }, {clearCache: 'nominas'})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Suministro.js